import Vue from 'vue'
import store from 'store'
import { mapActions } from 'vuex'
import on from 'dom-event'
import select from 'dom-select'
import Cookies from 'js-cookie'

export default el => Promise.all([
  enqueueModule('form-newsletter.vue'),
  enqueueModule('vue-image.vue')
]).then(() => new Vue({
  el,
  store,
  data () {
    return {
      showing: false,
      clickCount: 0,
      dataClickCount: 0
    }
  },
  created () {
    const dataClickCount = document.querySelector('.newsletter-bar__container').getAttribute('data-click-count')
    if (dataClickCount) {
      this.dataClickCount = parseInt(dataClickCount, 10) // Correctly reference dataClickCount
    }

    const body = select('body')

    on(body, 'click', (e) => {
      if ((Cookies.get('cookiesNotice')) && window.sessionStorage.getItem('newsletter') !== 'closed') {
        this.clickCount += 1
      }
    })
  },
  watch: {
    clickCount: {
      handler () {
        if (this.clickCount >= this.dataClickCount) {
          this.showing = true
          const divElement = document.querySelector('html')
          divElement.classList.add('newsletter-bar-active')
        }
      }
    }
  },
  methods: {
    close () {
      window.sessionStorage.setItem('newsletter', 'closed')
      this.showing = false
      const divElement = document.querySelector('html')
      divElement.classList.remove('newsletter-bar-active')
    }
  }
})
)
